import { AccountLink, AccountLinksApi } from 'oas/datasharing';
import { UseQueryResult } from '@tanstack/react-query';
import { useApiQuery } from '../../use-api-query';
import { API_NAMES } from '../../constants';

export const useGetAccountLinks = (options = {}): UseQueryResult<AccountLink[]> => {
    return useApiQuery(
        ['datasharing', 'account-links'],
        (apiConfig, axiosInstance) => new AccountLinksApi(apiConfig, '', axiosInstance).getAccountLinks(),
        options,
        'v6',
        API_NAMES.DATASHARING,
    );
};
